import { countryDataset, PhoneNumber } from 'components/Form'
import { noop } from 'utils'
import { AdvancedInputProps, BasicInputGroup } from '.'

export interface PhoneNumberInputProps extends AdvancedInputProps {
  value?: string
  countryCode?: string
}

export const PhoneNumberInput = ({
  name,
  label,
  value,
  countryCode,
  disabled,
  setFieldValue = noop,
  error,
  onBlur = noop,
  tabIndex,
}: PhoneNumberInputProps) => {
  const displayText = value || '-'
  return (
    <BasicInputGroup
      name={name}
      label={label}
      disabled={disabled}
      error={error}
      display={displayText}
      input={
        <PhoneNumber
          name={name}
          value={value}
          countryCodeValue={countryCode}
          countryCodes={countryDataset}
          disabled={disabled}
          hasErrors={!!error}
          onInputChange={(value) => setFieldValue(name, value)}
          onBlur={onBlur}
          tabIndex={tabIndex}
        />
      }
    />
  )
}
